import { Injectable } from '@angular/core';
import { HttpService } from '../../../shared/services/http/http-client.service';
import { environment } from '../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class ConsultaMovimentacoesPixService {

  constructor(
    private http: HttpService,
  ) { }

  getPixList(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/pix/list', data, successHandle, errorHandle);
  }

  getStatusArbiList(successHandle: Function, errorHandle: Function) {
    this.http.doGet('/pix/liststatusarbi', null, successHandle, errorHandle);
  }

  executeJob(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doPost('/jobScheduler/execute', data, successHandle, errorHandle);
  }
}
